<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Sinaleiras de Lucratividade">
      <div class="sinaleira-listagem">
        <Loading :isActive="loading" />

        <ModalSinaleiraLucratividade :item="currentItem" :close="closeEdit" />

        <div class="sinaleira-listagem__header">
          <CButton color="primary" @click="openCreate">
            <CIcon name="cil-plus" size="sm" class="mr-1" />
            Nova Sinaleira
          </CButton>
        </div>

        <div class="sinaleira-listagem__filtros">
          <CRow>
            <CCol md="4">
              <div class="filtro-search-wrapper">
                <CIcon name="cil-magnifying-glass" size="sm" class="filtro-search-icon" />
                <input
                  class="form-control filtro-search-input"
                  type="text"
                  v-model="filtros.termo"
                  placeholder="Buscar por título..."
                  @keyup.enter="loadSinaleiras"
                />
              </div>
            </CCol>
            <CCol md="2">
              <select class="form-control" v-model="filtros.ativo">
                <option value="">Ativo: Todos</option>
                <option value="1">Ativo: Sim</option>
                <option value="0">Ativo: Não</option>
              </select>
            </CCol>
            <CCol md="2">
              <select class="form-control" v-model="filtros.aplicafv">
                <option value="">FV: Todos</option>
                <option value="1">FV: Sim</option>
                <option value="0">FV: Não</option>
              </select>
            </CCol>
            <CCol md="2">
              <select class="form-control" v-model="filtros.aplicacallcenter">
                <option value="">CC: Todos</option>
                <option value="1">CC: Sim</option>
                <option value="0">CC: Não</option>
              </select>
            </CCol>
            <CCol md="2">
              <CButton color="primary" block @click="loadSinaleiras()">
                <CIcon name="cil-magnifying-glass" size="sm" class="mr-1" />
                Buscar
              </CButton>
            </CCol>
          </CRow>
        </div>

        <div class="sinaleira-listagem__table-wrapper">
          <table class="sinaleira-listagem__table">
            <thead>
              <tr>
                <th class="col-id">ID</th>
                <th class="col-titulo">Título</th>
                <th class="col-prio">Prioridade</th>
                <th class="col-sistema">FV</th>
                <th class="col-sistema">CC</th>
                <th class="col-data">Criação</th>
                <th class="col-ativo">Ativo</th>
                <th class="col-acoes"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="sinaleiras.length === 0">
                <td colspan="8" class="sinaleira-listagem__empty">
                  <CIcon name="cil-ban" size="xl" class="sinaleira-listagem__empty-icon" />
                  <p>Nenhuma sinaleira encontrada</p>
                </td>
              </tr>
              <tr
                v-for="sinaleira in sinaleiras"
                :key="sinaleira.id"
                class="sinaleira-listagem__row"
              >
                <td class="col-id">{{ sinaleira.id }}</td>
                <td class="col-titulo">
                  <span class="sinaleira-listagem__titulo">{{ sinaleira.titulo }}</span>
                </td>
                <td class="col-prio">
                  <span
                    class="sistema-badge"
                    :class="sinaleira.prioridade ? 'sistema-badge--ativo' : 'sistema-badge--inativo'"
                  >
                    {{ sinaleira.prioridade ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td class="col-sistema">
                  <span
                    class="sistema-badge"
                    :class="sinaleira.aplicafv ? 'sistema-badge--ativo' : 'sistema-badge--inativo'"
                  >
                    {{ sinaleira.aplicafv ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td class="col-sistema">
                  <span
                    class="sistema-badge"
                    :class="sinaleira.aplicacallcenter ? 'sistema-badge--ativo' : 'sistema-badge--inativo'"
                  >
                    {{ sinaleira.aplicacallcenter ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td class="col-data">{{ sinaleira.datahora_criacao }}</td>
                <td class="col-ativo">
                  <span
                    class="sistema-badge"
                    :class="sinaleira.ativo ? 'sistema-badge--ativo' : 'sistema-badge--inativo'"
                  >
                    {{ sinaleira.ativo ? 'Sim' : 'Não' }}
                  </span>
                </td>
                <td class="col-acoes">
                  <CButton
                    size="sm"
                    color="secondary"
                    @click="duplicateSinaleira(sinaleira)"
                    title="Duplicar"
                  >
                    <fa-icon icon="clone" />
                  </CButton>
                  <CButton
                    size="sm"
                    color="primary"
                    @click="editSinaleira(sinaleira)"
                    title="Alterar"
                  >
                    <fa-icon icon="pencil-alt" />
                  </CButton>
                  <CButton
                    size="sm"
                    color="danger"
                    @click="deleteConfirm(sinaleira.id)"
                    title="Excluir"
                  >
                    <fa-icon icon="trash-alt" />
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="sinaleira-listagem__pagination">
          <pagination
            :data="table.paginator"
            :limit="5"
            @pagination-change-page="loadSinaleiras"
          />
        </div>
      </div>
    </CTab>
  </CTabs>
</template>

<script>
import { get, del } from "@/helpers/apiRequest";
import clone from "just-clone";
import Loading from "@/components/Loading.vue";
import ModalSinaleiraLucratividade from "./ModalSinaleiraLucratividade/ModalSinaleiraLucratividade.vue";

function defaultSinaleira() {
  return {
    id: null,
    titulo: "",
    descricao: "",
    margemMinimaAnalisar: null,
    margemMinimaLiberar: null,
    ativo: 1,
    exibirPercentual: 0,
    modoAnalise: "PADRAO",
    prioridade: 0,
    aplicafv: 0,
    aplicacallcenter: 0,
    regras: [],
    restricoes: [],
  };
}

export default {
  name: "SinaleiraLucratividade",
  components: {
    Loading,
    ModalSinaleiraLucratividade,
  },
  data() {
    return {
      loading: false,
      currentItem: defaultSinaleira(),
      sinaleiras: [],
      filtros: {
        termo: "",
        ativo: "",
        aplicafv: "",
        aplicacallcenter: "",
      },
      table: {
        paginator: {},
      },
    };
  },
  methods: {
    loadSinaleiras(page = 1) {
      this.loading = true;
      const { termo, ativo, aplicafv, aplicacallcenter } = this.filtros;

      get(
        `/admin/sinaleira-lucratividade?page=${page}&take=15&q=${termo}&ativo=${ativo}&aplicafv=${aplicafv}&aplicacallcenter=${aplicacallcenter}&column=id&order=ASC`
      )
        .then((json) => {
          this.sinaleiras = json.itens;
          this.table.paginator = json.paginator;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    openCreate() {
      this.currentItem = defaultSinaleira();
      this.$modal.show("ModalSinaleiraLucratividade");
    },
    editSinaleira(sinaleira) {
      const cloned = clone(sinaleira);
      cloned.regras = cloned.regras?.data || cloned.regras || [];
      cloned.restricoes = cloned.restricoes?.data || cloned.restricoes || [];
      cloned.exibirPercentual = cloned.exibirPercentual ? 1 : 0;
      cloned.modoAnalise = cloned.modoAnalise || "PADRAO";
      this.currentItem = cloned;
      this.$modal.show("ModalSinaleiraLucratividade");
    },
    duplicateSinaleira(sinaleira) {
      const cloned = clone(sinaleira);
      cloned.id = null;
      cloned.titulo = `Cópia de ${cloned.titulo}`;
      cloned.exibirPercentual = cloned.exibirPercentual ? 1 : 0;
      cloned.modoAnalise = cloned.modoAnalise || "PADRAO";
      cloned.regras = (cloned.regras?.data || cloned.regras || []).map((r) => ({
        ...r,
        id: null,
        sinaleira_id: null,
      }));
      cloned.restricoes = (
        cloned.restricoes?.data ||
        cloned.restricoes ||
        []
      ).map((r) => ({ ...r, id: null, sinaleira_id: null }));
      this.currentItem = cloned;
      this.$modal.show("ModalSinaleiraLucratividade");
    },
    closeEdit() {
      this.$modal.hide("ModalSinaleiraLucratividade");
      this.loadSinaleiras();
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirmar exclusão da sinaleira?",
        html: `
          <p>Todas as <strong>negociações pendentes ou autorizadas com orçamento em aberto</strong> que utilizam essa sinaleira serão <strong>canceladas</strong>.</p>
          <p>Essa ação não poderá ser desfeita.</p>
        `,
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/sinaleira-lucratividade/${id}`)
              .then(() => {
                this.loadSinaleiras();
              })
              .catch((err) => {
                this.$swal({
                  title: "Falha ao remover",
                  text: err.message,
                  icon: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        })
        .catch(() => {});
    },
  },
  beforeMount() {
    this.loadSinaleiras();
  },
};
</script>

<style scoped>
/* ===== HEADER ===== */
.sinaleira-listagem__header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}

/* ===== FILTROS ===== */
.sinaleira-listagem__filtros {
  margin-bottom: 20px;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
}

.sinaleira-listagem__filtros .form-control {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
}

.sinaleira-listagem__filtros .form-control:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.filtro-search-wrapper {
  position: relative;
}

.filtro-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  z-index: 1;
}

.filtro-search-input {
  padding-left: 36px !important;
}

/* ===== TABLE ===== */
.sinaleira-listagem__table-wrapper {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: clip;
  background: #fff;
  margin-bottom: 20px;
}

.sinaleira-listagem__table {
  width: 100%;
  border-collapse: collapse;
}

.sinaleira-listagem__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7eb;
}

.sinaleira-listagem__table th {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 12px 12px;
  white-space: nowrap;
}

.sinaleira-listagem__table td {
  padding: 12px 12px;
  border-bottom: 1px solid #f2f4f7;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.sinaleira-listagem__row:last-child td {
  border-bottom: none;
}

.sinaleira-listagem__row:hover {
  background: #f9fafb;
}

.col-id { width: 60px; text-align: center; }
.col-titulo { }
.col-prio { width: 90px; text-align: center; }
.col-sistema { width: 50px; text-align: center; }
.col-data { width: 120px; text-align: center; }
.col-ativo { width: 70px; text-align: center; }
.col-acoes { width: 120px; text-align: center; white-space: nowrap; }

.sinaleira-listagem__titulo {
  font-weight: 500;
  color: #1d2939;
}

/* ===== BADGES ===== */
.sistema-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.sistema-badge--ativo {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}

.sistema-badge--inativo {
  background: #f5f5f5;
  color: #999;
  border: 1px solid #e0e0e0;
}

/* ===== EMPTY STATE ===== */
.sinaleira-listagem__empty {
  text-align: center;
  padding: 48px 20px !important;
  color: #98a2b3;
}

.sinaleira-listagem__empty-icon {
  color: #d0d5dd;
  margin-bottom: 8px;
}

.sinaleira-listagem__empty p {
  font-size: 13px;
  margin: 0;
}

/* ===== PAGINATION ===== */
.sinaleira-listagem__pagination {
  display: flex;
  justify-content: center;
}

/* ===== ACTIONS ===== */
.col-acoes .btn {
  margin: 0 2px;
}
</style>
